<template>
  <div class="form-select-list" :class="{ 'form-select-list__disabled': disable }">
    <div class="form-select-list__head">
      <div class="title">{{ label }}</div>
      <div
        v-if="containerType.length === 0 && disable === false"
        class="add_list"
        @click="onAddListElem(fieldname, inputOptions, list)"
      >
        {{ list.length === 0 ? "Добавить" : "Добавить / Удалить" }}
      </div>
      <div
        v-if="containerType.length > 0"
        v-hidden="containerType + '-waste-area:edit'"
        class="add_list"
        @click="onAddListElem(fieldname, inputOptions, list)"
      >
        {{ list.length === 0 ? "Добавить" : "Добавить / Удалить" }}
      </div>
    </div>
    <div class="form-select-list__list">
      <div v-for="(item, index) in list" :key="index" class="list_item">
        <div v-if="listItemHead.length > 0" class="list_item--head">{{ listItemHead }}</div>
        <div class="list_item--name">{{ item.name ? item.name : "нет имени" }}</div>
        <div class="settings" />
        <div v-if="containerType.length === 0" class="delete-item" @click="onDeleteItem(item)"></div>
        <div
          v-if="containerType.length > 0"
          v-hidden="containerType + '-waste-area:edit'"
          class="delete-item"
          @click="onDeleteItem(item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "FormSelectList",
  props: {
    inputModel: {
      type: Array,
      default: () => []
    },
    inputOptions: {
      type: Array,
      default: () => []
    },
    fieldname: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    containerType: {
      type: String,
      default: ""
    },
    listItemHead: {
      type: String,
      default: ""
    },
    onAddListElem: {
      type: Function,
      default: () => {
        alert("no onAddListElem func");
      }
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    list: {
      get() {
        return this.inputModel;
      },
      set(newValue) {
        this.$emit("update", { value: newValue, fieldname: this.fieldname });
      }
    }
  },
  methods: {
    ...mapActions(["getSource"]),
    onDeleteItem(el) {
      this.list = this.list.filter(s => s.id !== el.id);
    }
  }
};
</script>
